import React from "react";
import { GiftIcon, HardHatIcon, RefreshCwIcon, SearchIcon, TriangleAlertIcon, BoxIcon } from "lucide-react";
import { differentiators } from "../data/content";
import { DifferentiatorIcon } from "../types/content";
const ICONS: Record<DifferentiatorIcon, BoxIcon> = {
  hardhat: HardHatIcon,
  search: SearchIcon,
  alert: TriangleAlertIcon,
  gift: GiftIcon,
  refresh: RefreshCwIcon
};
export function Differentiators() {
  return <section className="bg-carbon px-3 py-4 sm:px-6" data-id="element-30" data-mp="zebrwhl3mzzq">
      <div className="mx-auto max-w-2xl text-center" data-id="element-31" data-mp="13e2nqzphg6b4">
        <h2 className="font-display text-[1.5rem] font-bold uppercase leading-none text-white sm:text-[2.1rem]" data-id="element-32" data-mp="13em9ysm61guy">
          THIS ISN'T JUST ANOTHER WORKPLACE SAFETY EBOOK
        </h2>
        <p className="mt-1 text-[0.78rem] font-extrabold uppercase tracking-wide text-safety sm:text-[0.95rem]" data-id="element-33" data-mp="1ddbfrn0sfauu">
          IT'S A READY-TO-USE INSPECTION SYSTEM.
        </p>
        <div className="mt-2 grid gap-1.5 text-left sm:grid-cols-2" data-id="element-34" data-mp="2oqw2q7j9jv0n">
          {differentiators.map((item, i) => {
          const Icon = ICONS[item.icon];
          const isLastOdd = i === differentiators.length - 1 && differentiators.length % 2 === 1;
          return <div key={item.title} className={`rounded-md border border-steel/60 bg-graphite px-2.5 py-2 ${isLastOdd ? 'sm:col-span-2' : ''}`} data-id="element-35" data-mp="7lebx3vqz0sn" data-mpi={i}>
                <h3 className="flex items-center gap-1.5 text-[0.8rem] font-extrabold text-white sm:text-[0.92rem]" data-id="element-36" data-mp="3ttdvc3480mr7">
                  <Icon className="h-4 w-4 shrink-0 text-warning" strokeWidth={2.25} aria-hidden="true" data-id="element-37" data-mp="3owx7la0xoaen" />
                  {item.title}
                </h3>
                <p className="mt-0.5 text-[0.76rem] leading-[1.35] text-mist sm:text-[0.86rem]" data-id="element-38" data-mp="3g2sj2x99vb2a">{item.body}</p>
              </div>;
        })}
        </div>
        <p className="mt-2 text-[0.76rem] font-extrabold uppercase tracking-wide text-white sm:text-[0.9rem]" data-id="element-39" data-mp="3b5sfcszwakec">
          Less improvisation. Fewer scattered records.{' '}
          <span className="text-safety" data-id="element-40" data-mp="316t5x87b2kqa">More structured safety inspections.</span>
        </p>
      </div>
    </section>;
}